"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const const_1 = require("@app/const");
const util_1 = require("@app/util");
const react_dom_1 = require("@floating-ui/react-dom");
const _ui_1 = require("@ui");
const classnames_1 = __importDefault(require("classnames"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const connect_1 = __importDefault(require("./connect"));
require("./index.scss");
class HeaderCol extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.resetState = this._resetState.bind(this);
        this.state = {
            dayNote: null,
        };
    }
    _resetState() {
        this.setState((s) => Object.assign({}, { dayNote: undefined }));
    }
    shouldComponentUpdate(nextProps, nextState) {
        // update if state changes (state only holds dayNote)
        if (nextState.dayNote !== this.state.dayNote) {
            return true;
        }
        if (util_1.miscUtil.safeStringify(this.props.customCalendar && (this.props.cols || '')) !==
            util_1.miscUtil.safeStringify(nextProps.customCalendar && (nextProps.cols || ''))) {
            return true;
        }
        // update if anything relevant in calendar changes
        if ((this.props.calendar ? this.props.calendar.date : '') !==
            (nextProps.calendar ? nextProps.calendar.date : '')) {
            this.resetState();
            return true;
        }
        if (util_1.miscUtil.safeStringify(this.props.col ? this.props.col : '') !==
            util_1.miscUtil.safeStringify(nextProps.col ? nextProps.col : '')) {
            return true;
        }
        if ((this.props.calendar ? this.props.calendar.view : '') !==
            (nextProps.calendar ? nextProps.calendar.view : '')) {
            this.resetState();
            return true;
        }
        if (util_1.miscUtil.safeStringify(this.props.calendar ? this.props.calendar.loadedPeriods : '') !==
            util_1.miscUtil.safeStringify(nextProps.calendar ? nextProps.calendar.loadedPeriods : '')) {
            return true;
        }
        // update if workspace events change (store slice - stable reference until it changes)
        if (this.props.workspaceEvents !== nextProps.workspaceEvents) {
            return true;
        }
        // update if workspace warnings filter change
        if (util_1.miscUtil.safeStringify(this.props.warnings) !==
            util_1.miscUtil.safeStringify(nextProps.warnings)) {
            return true;
        }
        // update if holidays change (store slice - stable reference until it changes)
        if (this.props.holidays !== nextProps.holidays) {
            return true;
        }
        return false;
    }
    render() {
        const { col, cols, withoutTooltip, customChildren, labelWidthRem, setModal, setCalendar, clearLiveDay, createWorkspaceEvent, deleteWorkspaceEvent, toggleTargetCalendarMultiSelect, workspaceEvents, holidays, workspace, isCyclePreview, warnings, } = this.props;
        const isDayView = typeof col.hour !== typeof undefined;
        const isToday = !isDayView && (0, moment_1.default)(col.date).isSame((0, moment_1.default)(), 'day');
        const isWeekend = col.date &&
            ((0, moment_1.default)(col.date).isoWeekday() === 6 || (0, moment_1.default)(col.date).isoWeekday() === 7);
        const day = (0, util_1.formatYYYYMMDD)((0, moment_1.default)(col.date));
        const dayIsClosed = workspaceEvents.find((evt) => evt.type === 'closed' &&
            (0, util_1.formatYYYYMMDD)((0, moment_1.default)(evt.period.start)) ===
                (col.date && (0, util_1.formatYYYYMMDD)(col.date)));
        const dayIsHoliday = holidays.find((hol) => hol.type === 'public' &&
            (0, util_1.formatYYYYMMDD)((0, moment_1.default)(hol.date)) ===
                (col.date && (0, util_1.formatYYYYMMDD)(col.date)));
        const noteEvt = isDayView
            ? null
            : workspaceEvents
                .reverse()
                .find((evt) => evt.type === 'note' &&
                (0, util_1.formatYYYYMMDD)((0, moment_1.default)(evt.period.start).endOf('day')) ===
                    (col.date && (0, util_1.formatYYYYMMDD)(col.date.endOf('day'))));
        const dayIsLocked = !!workspace &&
            !!workspace.calendarLockedUntil &&
            (0, moment_1.default)(workspace.calendarLockedUntil).isAfter((0, moment_1.default)(col.date).endOf('day'));
        const colStyle = {
            width: 'calc((100% - ' +
                labelWidthRem.toString() +
                'rem) / ' +
                cols.length.toString() +
                ')',
            minWidth: 'calc((100% - ' +
                labelWidthRem.toString() +
                'rem) / ' +
                cols.length.toString() +
                ')',
            maxWidth: 'calc((100% - ' +
                labelWidthRem.toString() +
                'rem) / ' +
                cols.length.toString() +
                ')',
        };
        const warningsArray = warnings
            ? Object.keys(warnings).map((w) => {
                return {
                    name: w,
                    value: warnings[w],
                };
            })
            : [];
        if (customChildren) {
            return col;
        }
        const mainContent = (react_1.default.createElement("div", { className: isDayView || withoutTooltip
                ? (0, classnames_1.default)('ds-c-col-dayview ds-c-col', util_1.calendarUtil.getColIdentifier(day, 'day'), isCyclePreview ? 'is-preview' : '', {
                    'is-today': isToday,
                    'is-weekend': isWeekend,
                    'has-note': noteEvt?.description,
                })
                : 'tooltip-anchor ', style: isDayView ? colStyle : null, key: isDayView ? col.hour : null, onClick: (e) => {
                // toggle target selection
                if (document.getElementsByClassName('is-multiselect-active').length) {
                    toggleTargetCalendarMultiSelect({
                        date: (0, util_1.formatYYYYMMDD)(col.date),
                        userId: 'day',
                    });
                    e.stopPropagation();
                }
            } },
            !isDayView ? (react_1.default.createElement("div", { className: 'ds-c-col-weekday' }, col.date.format('ddd'))) : null,
            !isDayView ? (react_1.default.createElement("div", { className: 'ds-c-col-monthday' }, (0, util_1.formatD)(col.date))) : (react_1.default.createElement("div", { className: 'ds-c-col-hour' }, col.hour.toString() + ':00'))));
        if (isDayView || withoutTooltip || customChildren) {
            return mainContent;
        }
        else {
            return (react_1.default.createElement("div", { key: 'header_col_' +
                    (typeof col.hour === typeof undefined
                        ? (0, util_1.formatYYYYMMDD)(col.date)
                        : col.hour.toString()), className: (0, classnames_1.default)('ds-c-col', util_1.calendarUtil.getColIdentifier(day, 'day'), {
                    'is-today': isToday,
                    'is-weekend': isWeekend,
                    'has-note': noteEvt?.description,
                    'is-holiday': dayIsHoliday,
                    'is-closed': dayIsClosed,
                }), style: colStyle },
                react_1.default.createElement(_ui_1.Tooltip, { delayBeforeClose: 20, delayBeforeOpen: 100, width: '14rem', position: _ui_1.Tooltip.POSITIONS.BOTTOM_END, anchor: mainContent, className: 'ds-c-tooltip-content', middleware: [
                        (0, react_dom_1.flip)({
                            fallbackPlacements: [
                                _ui_1.Tooltip.POSITIONS.BOTTOM_START,
                                _ui_1.Tooltip.POSITIONS.BOTTOM_END,
                                _ui_1.Tooltip.POSITIONS.BOTTOM,
                            ],
                            fallbackStrategy: 'initialPlacement',
                            padding: 32,
                        }),
                    ] },
                    react_1.default.createElement("div", { className: 'ds-title' }, col.date.format('dddd D.M. YYYY')),
                    dayIsHoliday ? (react_1.default.createElement("div", { className: 'ds-c-tt-holiday' }, dayIsHoliday.name)) : null,
                    util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                setCalendar({ date: day, view: 'day' });
                            } }, (0, util_1.t)('VIEW_DAY_SCHEDULE')),
                        react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                setModal('copy-period', {
                                    forceCalendarSettings: {
                                        view: 'day',
                                        date: day,
                                    },
                                });
                            } }, (0, util_1.t)('COPY_DAY')),
                        react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                setModal('template-create', { date: day });
                                // this.props.openModal(ShiftModal, {
                                //   initialData: {
                                //     type: 'template'
                                //   }
                                // })
                            } }, (0, util_1.t)('SAVE_DAY_AS_TEMPLATE')),
                        !dayIsLocked && (react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                setModal('template-apply', { date: day });
                            } }, (0, util_1.t)('APPLY_TEMPLATE_LIVE'))),
                        !dayIsLocked && (react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                setModal('confirm', {
                                    title: 'CLEAR_DAY',
                                    subtitle: (0, util_1.t)('CLEAR_DAY_CONFIRM_SUBTITLE'),
                                    text: (react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_16 },
                                        react_1.default.createElement("div", { style: { width: '100%' } }, (0, util_1.t)('CLEAR_DAY_CONFIRM_TXT_X', {
                                            x: (0, moment_1.default)(day).format('D. M. YYYY'),
                                        })))),
                                    confirmLabel: (0, util_1.t)('CLEAR_DAY'),
                                    onConfirm: () => {
                                        clearLiveDay(day);
                                    },
                                    cancelLabel: (0, util_1.t)('CANCEL'),
                                    onCancel: () => { },
                                    overSidebar: true,
                                    buttonColor: 'red',
                                });
                            } }, (0, util_1.t)('CLEAR_DAY'))),
                        dayIsClosed ? (react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                deleteWorkspaceEvent({
                                    id: dayIsClosed.id,
                                });
                            } }, (0, util_1.t)('SET_AS_OPEN'))) : (react_1.default.createElement("div", { className: 'ds-c-header-tooltip-btn', onClick: (e) => {
                                createWorkspaceEvent({
                                    type: 'closed',
                                    period: {
                                        start: col.date.clone().add(12, 'hours').startOf('day'),
                                        end: col.date.clone().add(12, 'hours').endOf('day'),
                                    },
                                });
                            } }, (0, util_1.t)('SET_AS_CLOSED'))))),
                    (util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR) ||
                        !!noteEvt?.description) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(_ui_1.Textarea, { disabled: !util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR), onClick: (e) => {
                                e.stopPropagation();
                            }, label: (0, util_1.t)('NOTE') + ':', placeholder: '', size: 'full-width', value: (0, util_1.isValue)(this.state.dayNote)
                                ? this.state.dayNote
                                : (0, util_1.isValue)(noteEvt?.description)
                                    ? noteEvt?.description
                                    : '-', rows: typeof this.state.dayNote === 'string' &&
                                (this.state.dayNote.length > 40 ||
                                    (this.state.dayNote.match(/\n/g) || []).length > 1)
                                ? 12
                                : typeof noteEvt?.description === 'string' &&
                                    (noteEvt.description.length > 40 ||
                                        (noteEvt.description.match(/\n/g) || []).length > 1)
                                    ? 12
                                    : undefined, onChange: (val) => {
                                this.setState((s) => Object.assign({}, s, { dayNote: val }));
                            }, onBlur: () => {
                                if (this.state.dayNote && this.state.dayNote.trim() !== '') {
                                    const noteEvt = workspaceEvents.find((evt) => evt.type === 'note' &&
                                        (0, util_1.formatYYYYMMDD)((0, moment_1.default)(evt.period.start)) ===
                                            (0, util_1.formatYYYYMMDD)(col.date));
                                    if (noteEvt) {
                                        deleteWorkspaceEvent({
                                            id: noteEvt.id,
                                        });
                                    }
                                    createWorkspaceEvent({
                                        type: 'note',
                                        period: {
                                            start: col.date.clone().startOf('day'),
                                            end: col.date.clone().endOf('day'),
                                        },
                                        description: this.state.dayNote,
                                    });
                                }
                                else {
                                    if (typeof this.state.dayNote === 'string' &&
                                        this.state.dayNote.trim() === '') {
                                        // manual deletion of the note (when user changes the note to empty string)
                                        const noteEvt = workspaceEvents.find((evt) => evt.type === 'note' &&
                                            (0, util_1.formatYYYYMMDD)((0, moment_1.default)(evt.period.start)) ===
                                                (0, util_1.formatYYYYMMDD)(col.date));
                                        if (noteEvt) {
                                            deleteWorkspaceEvent({
                                                id: noteEvt.id,
                                            });
                                        }
                                    }
                                }
                            } }))),
                    warningsArray.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(_ui_1.Separator, { side: _ui_1.Separator.SIDES.BOTTOM, size: _ui_1.Separator.SIZES.FULL_WIDTH }),
                        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_16, type: _ui_1.Spacing.TYPES.BOTH },
                            react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN },
                                        react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('WARNINGS')),
                                        react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_32, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                                        react_1.default.createElement(_ui_1.Link, { to: '/backoffice/reports/warnings', type: _ui_1.Link.TYPES.ROUTER_LINK },
                                            react_1.default.createElement(_ui_1.Text, { color: _ui_1.Text.COLORS.PRIMARY, type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, style: { textDecoration: 'underline' } }, (0, util_1.t)('WARNINGS_HOW_RESOLVE')))),
                                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8 }),
                                    react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN }, warningsArray.map((war) => {
                                        return (react_1.default.createElement(_ui_1.Flex, { key: `${day}${war.name}${war.value}`, direction: _ui_1.Flex.DIRECTION.COLUMN },
                                            react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.SPC_BETWEEN, align: _ui_1.Flex.POSITION.CENTER },
                                                react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, color: _ui_1.Text.COLORS.DANGER, weight: _ui_1.Text.WEIGHTS.MEDIUM }, (0, util_1.t)('WARNING_' + war.name)),
                                                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_8, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                                                react_1.default.createElement(_ui_1.CircledNumber, { number: war.value, color: _ui_1.CircledNumber.COLORS.DANGER })),
                                            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_6 })));
                                    }))))))))));
        }
    }
}
exports.default = (0, connect_1.default)(HeaderCol);
